import React from "react"
import { ITimezone, IDate } from "../../models"
import * as timeHelper from "../../helpers/timeHelper"
import moment from "moment"

interface IProps {
    hierarchyId: string
    jobId: string

    utcTime?: IDate
    // it's browser local time
    localTime?: IDate
}

const HierarchyJobTimezoneStr: React.SFC<IProps> = (props: IProps) => {
    return (props.utcTime || props.localTime) ?
        <HierarchyJobTimezoneStrForSpecificTime
            hierarchyId={props.hierarchyId}
            jobId={props.jobId}
            utcTime={props.utcTime}
            localTime={props.localTime}
        /> :
        <HierarchyJobTimezoneStrForCurrent
            hierarchyId={props.hierarchyId}
            jobId={props.jobId}
        />
}

export default HierarchyJobTimezoneStr

interface IHierarchyJobTimezoneStrForSpecificTimeProps {
    hierarchyId: string
    jobId: string

    utcTime: IDate
    // it's client local time utc format
    localTime: IDate
}
interface IHierarchyJobTimezoneStrForSpecificTimeState {
    IANATimezoneName: string
    timezoneOffsetByTime: number
}

class HierarchyJobTimezoneStrForSpecificTime extends React.Component<IHierarchyJobTimezoneStrForSpecificTimeProps, IHierarchyJobTimezoneStrForSpecificTimeState>  {
    constructor(props: IHierarchyJobTimezoneStrForSpecificTimeProps) {
        super(props)
        this.state = {
            IANATimezoneName: null,
            timezoneOffsetByTime: null
        }
    }

    async componentDidMount() {
        const IANATimezoneName = await timeHelper.getIANATimezoneNameFromHierarchyJobId(this.props.hierarchyId, this.props.jobId)
        this.setState({ IANATimezoneName })
    }

    async componentWillReceiveProps(nextProps: IHierarchyJobTimezoneStrForSpecificTimeProps) {
        if (this.props.hierarchyId !== nextProps.hierarchyId || this.props.jobId !== nextProps.jobId) {
            const IANATimezoneName = await timeHelper.getIANATimezoneNameFromHierarchyJobId(nextProps.hierarchyId, nextProps.jobId)
            this.setState({ IANATimezoneName })
        }
    }

    render() {

        if (!this.state.IANATimezoneName) return null
        let utcTime
        if (this.props.utcTime) {
            utcTime = this.props.utcTime
        }
        else if (this.props.localTime) {
            const localTimeMoment = moment(this.props.localTime)
            utcTime = timeHelper.getTimezoneTranslatedDateTime(localTimeMoment, localTimeMoment.minute(), localTimeMoment.hour(), this.state.IANATimezoneName)
        }
        const timezoneOffset = moment.tz(utcTime, this.state.IANATimezoneName).utcOffset()
        const offsetFormatted = timezoneOffset >= 0 ? '+' : '-'
        const offsetHours = Math.abs(Math.floor(timezoneOffset / 60))
        const offsetMinutes = Math.abs(timezoneOffset) % 60
        return (
            <span>
                {`GMT${offsetFormatted}${offsetHours.toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`}
            </span>
        )
    }
}

interface IHierarchyJobTimezoneStrForCurrentProps {
    hierarchyId: string
    jobId: string
}
interface IHierarchyJobTimezoneStrForCurrentState {
    timezone: ITimezone
}

class HierarchyJobTimezoneStrForCurrent extends React.Component<IHierarchyJobTimezoneStrForCurrentProps, IHierarchyJobTimezoneStrForCurrentState>  {
    constructor(props: IHierarchyJobTimezoneStrForCurrentProps) {
        super(props)
        this.state = {
            timezone: null
        }
    }

    async componentDidMount() {
        const timezone = await timeHelper.getIANATimezoneFromHierarchyJobId(this.props.hierarchyId, this.props.jobId)
        this.setState({ timezone })
    }

    async componentWillReceiveProps(nextProps: IHierarchyJobTimezoneStrForCurrentProps) {
        if (this.props.hierarchyId !== nextProps.hierarchyId || this.props.jobId !== nextProps.jobId) {
            const timezone = await timeHelper.getIANATimezoneFromHierarchyJobId(nextProps.hierarchyId, nextProps.jobId)
            this.setState({ timezone })
        }
    }

    render() {
        if (!this.state.timezone) return null
        return (
            <span>
                {this.state.timezone.Label}
            </span>
        )
    }
}